import { render, staticRenderFns } from "./Archiver.vue?vue&type=template&id=1e673c06"
import script from "./Archiver.vue?vue&type=script&lang=js"
export * from "./Archiver.vue?vue&type=script&lang=js"
import style0 from "./Archiver.vue?vue&type=style&index=0&id=1e673c06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports